import s from "./LiquidGlassDefs.module.css"

/**
 * The liquid-glass lens (design system liquid-glass-v1, 2026-09-09): red bends
 * x, green bends y, inward at the edges, still in the middle. Referenced by the
 * decision panes' glass footers as `backdrop-filter: url(#lgRefract) …`.
 */
const MAP_X =
  "data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64' preserveAspectRatio='none'%3E%3ClinearGradient id='g' x1='0' y1='0' x2='1' y2='0'%3E%3Cstop offset='0' stop-color='rgb(255,0,0)'/%3E%3Cstop offset='0.22' stop-color='rgb(128,0,0)'/%3E%3Cstop offset='0.78' stop-color='rgb(128,0,0)'/%3E%3Cstop offset='1' stop-color='rgb(0,0,0)'/%3E%3C/linearGradient%3E%3Crect width='64' height='64' fill='url(%23g)'/%3E%3C/svg%3E"
const MAP_Y =
  "data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64' preserveAspectRatio='none'%3E%3ClinearGradient id='g' x1='0' y1='0' x2='0' y2='1'%3E%3Cstop offset='0' stop-color='rgb(0,255,0)'/%3E%3Cstop offset='0.3' stop-color='rgb(0,128,0)'/%3E%3Cstop offset='0.7' stop-color='rgb(0,128,0)'/%3E%3Cstop offset='1' stop-color='rgb(0,0,0)'/%3E%3C/linearGradient%3E%3Crect width='64' height='64' fill='url(%23g)'/%3E%3C/svg%3E"

export function LiquidGlassDefs({ id = 'lgRefract' }: { id?: string }) {
  return (
    <svg width="0" height="0" className={s.defs} aria-hidden="true" focusable="false">
      <filter id={id} x="0" y="0" width="100%" height="100%" colorInterpolationFilters="sRGB">
        <feImage result="mx" preserveAspectRatio="none" href={MAP_X} />
        <feImage result="my" preserveAspectRatio="none" href={MAP_Y} />
        <feComposite in="mx" in2="my" operator="arithmetic" k1="0" k2="1" k3="1" k4="0" result="map" />
        <feDisplacementMap in="SourceGraphic" in2="map" scale="22" xChannelSelector="R" yChannelSelector="G" />
      </filter>
    </svg>
  )
}
